/* IVDD Relief Vest lander — interactions (no dependencies) */
(function () {
  'use strict';
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---- countdown: evergreen timer per visitor (resets after it expires) ---- */
  $$('[data-ivdd-countdown]').forEach(function (el) {
    var hours = parseFloat(el.getAttribute('data-hours') || '12');
    var key = 'ivdd_cd_' + (el.getAttribute('data-key') || 'offer');
    var end;
    try { end = parseInt(localStorage.getItem(key), 10); } catch (e) { end = NaN; }
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 3600 * 1000;
      try { localStorage.setItem(key, String(end)); } catch (e) {}
    }
    var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]'), plain = el.querySelector('[data-hms]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.max(0, end - Date.now());
      var sec = Math.floor(left / 1000);
      var dd = Math.floor(sec / 86400), hh = Math.floor((sec % 86400) / 3600), mm = Math.floor((sec % 3600) / 60), ss = sec % 60;
      if (d) d.textContent = pad(dd);
      if (h) h.textContent = pad(hh);
      if (m) m.textContent = pad(mm);
      if (s) s.textContent = pad(ss);
      if (plain) plain.textContent = pad(hh + dd * 24) + ':' + pad(mm) + ':' + pad(ss);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---- "ships by" date: today + N calendar days (ships within 24h => tomorrow) ---- */
  $$('[data-ivdd-ships]').forEach(function (el) {
    var days = parseInt(el.getAttribute('data-days') || '1', 10);
    var dt = new Date();
    dt.setDate(dt.getDate() + days);
    el.textContent = dt.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  });

  /* ---- social proof counter: stable-per-day random in a range ---- */
  $$('[data-ivdd-bought]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min') || '250', 10), max = parseInt(el.getAttribute('data-max') || '420', 10);
    var day = Math.floor(Date.now() / 86400000);
    var x = Math.sin(day * 9301 + 49297) * 233280; x = x - Math.floor(x);
    el.textContent = String(min + Math.floor(x * (max - min + 1)));
  });

  /* ---- per-day price ---- */
  $$('[data-ivdd-perday]').forEach(function (el) {
    var price = parseFloat(el.getAttribute('data-price') || '0'), years = parseFloat(el.getAttribute('data-years') || '5');
    if (price > 0) el.textContent = '$' + (price / (years * 365)).toFixed(3).replace(/0$/, '');
  });

  /* ---- generic horizontal carousels (hero testimonials, videos) ---- */
  $$('[data-ivdd-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var slides = $$('[data-slide]', track);
    var dots = $$('[data-dot]', root);
    function slideWidth() { return slides[0] ? slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) : 0; }
    function index() { return Math.round(track.scrollLeft / (slideWidth() || 1)); }
    function go(i) {
      var n = slides.length; if (!n) return;
      i = ((i % n) + n) % n;
      track.scrollTo({ left: i * slideWidth(), behavior: 'smooth' });
    }
    $$('[data-prev]', root).forEach(function (b) { b.addEventListener('click', function () { go(index() - 1); }); });
    $$('[data-next]', root).forEach(function (b) { b.addEventListener('click', function () { go(index() + 1); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    function syncDots() { var i = index(); dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); }); }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); });
    syncDots();
    var auto = parseInt(root.getAttribute('data-autoplay') || '0', 10);
    if (auto > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var timer = setInterval(function () { if (!root.matches(':hover')) go(index() + 1); }, auto);
      root.addEventListener('pointerdown', function () { clearInterval(timer); });
    }
  });

  /* ---- video cards: click poster to play, pause others ---- */
  $$('[data-ivdd-video]').forEach(function (card) {
    var video = card.querySelector('video');
    if (!video) return;
    card.addEventListener('click', function () {
      $$('[data-ivdd-video] video').forEach(function (v) { if (v !== video) { v.pause(); v.closest('[data-ivdd-video]').classList.remove('is-playing'); } });
      if (video.paused) { video.muted = false; video.controls = true; video.play(); card.classList.add('is-playing'); }
      else { video.pause(); card.classList.remove('is-playing'); }
    });
    video.addEventListener('ended', function () { card.classList.remove('is-playing'); });
  });

  /* ---- before / after compare slider ---- */
  $$('[data-ivdd-compare]').forEach(function (el) {
    var input = el.querySelector('input[type=range]');
    if (!input) return;
    var set = function () { el.style.setProperty('--pos', input.value + '%'); };
    input.addEventListener('input', set); set();
  });

  /* ---- product gallery ---- */
  $$('[data-ivdd-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-main]');
    var thumbs = $$('[data-thumb]', g);
    var i = 0;
    function show(n) {
      if (!thumbs.length) return;
      i = ((n % thumbs.length) + thumbs.length) % thumbs.length;
      var src = thumbs[i].getAttribute('data-src');
      if (main && src) { main.src = src; main.alt = thumbs[i].querySelector('img') ? thumbs[i].querySelector('img').alt : ''; main.classList.toggle('is-contain', thumbs[i].getAttribute('data-fit') === 'contain'); }
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
    }
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });
    $$('[data-prev]', g).forEach(function (b) { b.addEventListener('click', function () { show(i - 1); }); });
    $$('[data-next]', g).forEach(function (b) { b.addEventListener('click', function () { show(i + 1); }); });
    var startX = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (startX === null) return; var dx = e.changedTouches[0].clientX - startX; if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1); startX = null; });
    }
    show(0);
  });

  /* ---- show more (reviews) ---- */
  $$('[data-ivdd-showmore]').forEach(function (btn) {
    var target = document.getElementById(btn.getAttribute('data-target'));
    if (!target) return;
    var step = parseInt(btn.getAttribute('data-step') || '4', 10);
    btn.addEventListener('click', function () {
      var hidden = $$('.is-hidden', target).slice(0, step);
      hidden.forEach(function (c) { c.classList.remove('is-hidden'); });
      if (!$$('.is-hidden', target).length) btn.style.display = 'none';
    });
    if (!$$('.is-hidden', target).length) btn.style.display = 'none';
  });

  /* ---- accordion: only one open per group (optional) ---- */
  $$('[data-ivdd-accordion-group]').forEach(function (group) {
    $$('details', group).forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) $$('details', group).forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  });

  /* ---- sticky mobile CTA: show after hero scrolled past, hide when buy box visible ---- */
  var sticky = document.querySelector('[data-ivdd-sticky]');
  var hero = document.querySelector('[data-ivdd-hero]');
  var buy = document.querySelector('[data-ivdd-buybox]');
  if (sticky && hero && 'IntersectionObserver' in window) {
    var heroOut = false, buyIn = false;
    function update() { sticky.classList.toggle('is-visible', heroOut && !buyIn); }
    new IntersectionObserver(function (en) { heroOut = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; update(); }, { threshold: 0 }).observe(hero);
    if (buy) new IntersectionObserver(function (en) { buyIn = en[0].isIntersecting; update(); }, { threshold: 0.05 }).observe(buy);
  }

  /* ---- popovers (size guide) ---- */
  $$('[data-ivdd-popover]').forEach(function (btn) {
    var pop = document.getElementById(btn.getAttribute('data-ivdd-popover'));
    if (!pop) return;
    var close = function () { pop.hidden = true; document.body.style.overflow = ''; };
    btn.addEventListener('click', function () { pop.hidden = false; document.body.style.overflow = 'hidden'; var c = pop.querySelector('[data-ivdd-popover-close]'); if (c) c.focus(); });
    pop.addEventListener('click', function (e) { if (e.target === pop || e.target.closest('[data-ivdd-popover-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
  });

  /* ---- inline toggles (refill "?" note) ---- */
  $$('[data-ivdd-toggle]').forEach(function (btn) {
    var box = document.getElementById(btn.getAttribute('data-ivdd-toggle'));
    if (!box) return;
    btn.addEventListener('click', function () { var open = box.hidden; box.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  });

  /* ---- smooth anchor scroll (header nav + CTAs to #offer) ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    var t = id && document.getElementById(id);
    if (!t) return;
    e.preventDefault();
    /* land on the offer itself: desktop shows both columns, mobile lands on the bundle box so price + button are in view */
    var narrow = window.matchMedia('(max-width: 767px)').matches;
    var inner = t.querySelector(narrow ? '.ivdd-box' : '.ivdd-offer__grid');
    var gap = narrow ? 96 : 16;
    if (inner) { t = inner; } else { gap = 56; }
    var top = t.getBoundingClientRect().top + window.pageYOffset - gap;
    window.scrollTo({ top: top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
})();
